const path = {
    proxyPath : "https://app.doublestruck.eu/data/proxy_viewer.php",
    contentPath: "https://app.doublestruck.eu/viewer/data/getQuestion.php",
    contentIMGPath: "https://contentproxy.doublestruck.eu/",
    resourcesPath : "https://ds-resources.doublestruck.eu/",
    resourcesFixPath: "https://app.doublestruck.eu/data/resource.php?s="
}
export {
    path
}
